import { Button, CircularProgress, Grid, Paper } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import React, { useEffect, useRef, useState } from "react";
import config from "react-global-configuration";
import { toast } from "react-toastify";
import { store } from "../../store";
import AdicionarProduto from "../../components/Orcamentos/Botoes/AdicionarProduto";
import CarregarModelo from "../../components/Orcamentos/Botoes/CarregarModelo";
import Duplicar from "../../components/Orcamentos/Botoes/Duplicar";
import SalvarModelo from "../../components/Orcamentos/Botoes/SalvarModelo";
import MetodosPagamento from "../../components/Orcamentos/MetodosPagamento";
import MetodosPagamentoSelecionado from "../../components/Orcamentos/MetodosPagamentoSelecionado";
import OrcamentoBaseTroca from "../../components/Orcamentos/OrcamentoBaseTroca";
import OrcamentoExtras from "../../components/Orcamentos/OrcamentoExtras";
import OrcamentoResumo from "../../components/Orcamentos/OrcamentoResumo";
import OrcamentoTopo from "../../components/Orcamentos/OrcamentoTopo";
import ProdutosAdicionados from "../../components/Orcamentos/Tabelas/ProdutosAdicionados";
import Cabecalho from "../../components/Pagina/Cabecalho";
import { carregaProdutos } from "../../components/Uteis.js/Modelos";
import {
	calculaValorFinalProduto,
	calculaValorUnitarioFinalProduto,
} from "../../components/Uteis.js/Monetario";

const OrcamentoPagina = (props) => {
	const urlParams = new URLSearchParams(window.location.search);
	const pagamentoMetodosRef = useRef();
	const [orcamentoProdutos, SetOrcamentoProdutos] = useState([]);
	const [orcamentoSalvo, SetOrcamentoSalvo] = useState([]);
	const [redirecionarAposSalvar, SetRedirecionarAposSalvar] = useState(false);
	const [orcamentoResumo, SetOrcamentoResumo] = useState({
		valorTotalSemDesconto: 0,
		totalSemDesconto: 0,
		totalComDesconto: "",
		porcentagemDeDesconto: 0,
		entrada: 0,
		totalParcelas: 0,
		frete: 0,
	});
	const [infoUsers, SetInfoUsers] = useState();
	const [paymentMethods, SetPagamentoMetodos] = useState();
	const [paymentMethodsOpen, SetPagamentoMetodosOpen] = useState([]);
	const [paymentMethodsSelecteds, SetPagamentoMetodosSelecteds] = useState();
	const [gruposDeProdutosLista, SetGruposDeProdutosLista] = useState();
  const [gruposDeProdutosLinha, setGruposDeProdutosLinha] = useState([]);
  const [gruposDeProdutosCor, setGruposDeProdutosCor] = useState([]);
	const [produtosIndisponiveis, SetProdutosIndisponiveis] = useState([]);
	const [produtosAlteracaoValor, SetProdutosAlteracaoValor] = useState([]);

	const [orcamentoExtras, SetOrcamentoExtras] = useState({
		comments: "",
		expirationDays: 10,
		baseTroca: false,
		baseTrocaProdutos: "",
		baseTrocaValor: "",
		cNFConsignadoOriginal: "",
		dNFConsignadoEmissao: "",
		nValorEntrada: "",
		versao: "2021-08-05",
		chamado_id: urlParams.get("astec_chamado_id")
			? urlParams.get("astec_chamado_id")
			: null,
	});

	const pipedriveDealId = urlParams.get("pipedriveDealId");
	const astecChamadoId = urlParams.get("astec_chamado_id");
	const [salvandoOrcamento, SetSalvandoOrcamento] = useState(false);
	const [compraProgramada, SetCompraProgramada] = useState([]);
	const [compraProgramadaSelecionada, SetCompraProgramadaSelecionada] =
		useState(false);
	const [mercadoPagoSemJuros, setMercadoPagoSemJuros] = useState([]);
	const [alertaMuitoDesconto, setAlertaMuitoDesconto] = useState(false);

	const carregarModelo = (modelData) => {
		const jsonDadosModelo = JSON.parse(modelData);
		// console.log("Carrega modelo", jsonDadosModelo);
		const carregaProdutosDados = carregaProdutos(
			jsonDadosModelo,
			gruposDeProdutosLista
		);

		SetProdutosIndisponiveis(carregaProdutosDados.produtosIndisponiveis);
		SetProdutosAlteracaoValor(carregaProdutosDados.produtosAlteracaoValor);
		AtualizaDadosOrcamento({
			listaPordutos: carregaProdutosDados.produtos,
			frete: jsonDadosModelo.resumo.frete,
			entrada: jsonDadosModelo.resumo.entrada,
		});
	};

	// Adiciona ou remove item
	const AdicionaRemoveProduto = (produtoId, tipo) => {
		console.log("AdicionaRemoveProduto-----------------", produtoId, tipo);
		const listaPordutos = [];
		orcamentoProdutos.map((item) => {
			if (item && item.id) {
				if (item.id !== produtoId) {
					listaPordutos.push(item);
				} else {
					const quantidade =
						tipo === "add" ? item.quantidade + 1 : item.quantidade - 1;
					if (quantidade > 0) {
						listaPordutos.push({
							id: item.id,
							nome: item.nome,
							categoria: item.categoria,
							valor_tabela: item.valor_tabela,
							valor_final: calculaValorFinalProduto(
								item,
								item.desconto,
								item.valor_tabela,
								quantidade
							),
							valor_unitario: calculaValorUnitarioFinalProduto(
								item,
								item.desconto,
								item.valor_tabela,
								quantidade
							),
							desconto: item.desconto,
							quantidade: quantidade,
						});
					}
				}
			}
		});
		console.log("listaPordutos", listaPordutos);
		AtualizaDadosOrcamento({ listaPordutos: listaPordutos });
	};

	useEffect(() => {
		fetch(
			config.get("url_api") + "orcamento/dados/negocio/" + pipedriveDealId,
			{
				method: "GET",
				headers: {
					"Content-Type": "application/json;charset=utf-8",
				},
			}
		)
			.then((res) => res.json())
			.then(
				(result) => {
					if (result.success) {
						SetInfoUsers(result);
					} else {
						toast.error(result.message);
					}
				},
				(error) => {
					toast.error("Erro ao recuperar dados do negócio. " + error);
				}
			);

		fetch(config.get("url_api") + "orcamento/formas-pagamento", {
			method: "GET",
			headers: {
				"Content-Type": "application/json;charset=utf-8",
			},
		})
			.then((res) => res.json())
			.then(
				(result) => {
					SetPagamentoMetodos(result.formasPagamento);
				},
				(error) => {
					toast.error("Erro ao recuperar formas de pagamento. " + error);
				}
			);

		const eAstec = astecChamadoId === null ? 0 : 1;
		const userData = store.getState().authReducer;
		
		// Debug: verificar dados do usuário
		console.log("Dados do usuário:", userData);
		console.log("userId:", userData.userId);
		
		const url =
			config.get("url_api") +
			"orcamento/grupos-produtos/lista?astec=" +
			eAstec +
			"&token=" +
			config.get("token") +
			(userData.userId ? "&userId=" + userData.userId : "");

		fetch(url, {
			method: "GET",
			headers: {
				"Content-Type": "application/json;charset=utf-8",
			},
		})
			.then((res) => res.json())
			.then(
				(result) => {
					SetGruposDeProdutosLista(result.produtos);
				},
				(error) => {
					toast.error("Erro ao recuperar formas de pagamento. " + error);
				}
			);

    const urlLinhaProdutos = config.get("url_api") + "orcamento/grupos-produtos/linha-produtos/lista" + "?token=" + config.get("token");
    fetch(urlLinhaProdutos, {
      method: "GET",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setGruposDeProdutosLinha(result.linhaProdutos);
        },
        (error) => {
          toast.error("Erro ao recuperar as linhas de produtos. " + error);
        }
      );

    const urlCorProdutos = config.get("url_api") + "orcamento/grupos-produtos/cor-produtos/lista" + "?token=" + config.get("token");
    fetch(urlCorProdutos, {
      method: "GET",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setGruposDeProdutosCor(result.coresProdutos);
        },
        (error) => {
          toast.error("Erro ao recuperar as linhas de produtos. " + error);
        }
      );

	}, [astecChamadoId, pipedriveDealId]);

	const updateCompraProgramada = () => {
		pagamentoMetodosRef.current.updateCompraProgramada();
	};

	const updateMercadoPagoSemJuros = (value) => {
		// console.log("OrcamentoPagina::updateMercadoPagoSemJuros");
		pagamentoMetodosRef.current.updateMercadoPagoSemJuros(value);
	};

	const AtualizaDadosOrcamento = (dados) => {
		// console.log("AtualizaDadosOrcamento----------------->");
		let porcentagemDeDesconto = null;
		let listaPordutos = null;
		let entrada = null;
		let frete = null;
		let listaAtualizada = false;

		// Altera por valor com desconto
		if (dados.valorComDesconto) {
			// console.log("Altera por valor com desconto");
			const desconto =
				100 - (dados.valorComDesconto / orcamentoResumo.totalSemDesconto) * 100;

			listaPordutos = orcamentoProdutos.map((item) => {
				console.log("item", item);
				if (item && item.quantidade && item.valor_tabela) {
					let novo = {};
					novo = {
						...item,
						desconto: desconto,
						valor_final: calculaValorFinalProduto(
							item,
							desconto,
							item.valor_tabela,
							item.quantidade
						),
						valor_unitario: calculaValorUnitarioFinalProduto(
							item,
							desconto,
							item.valor_tabela
						),
					};

					return novo;
				}
			});
			listaAtualizada = true;
			porcentagemDeDesconto = desconto;
		}
		// Altera por porcentagem geral de desconto
		else if (dados.porcentagemDeDesconto || dados.porcentagemDeDesconto === 0) {
			// console.log("Altera por porcentagem geral de desconto");
			let porcentagem = dados.porcentagemDeDesconto;

			listaPordutos = orcamentoProdutos.map((item) => {
				console.log(item, porcentagem);
				if (item && item.quantidade && item.valor_tabela) {
					let novo = {};
					novo = {
						...item,
						desconto: porcentagem,
						valor_final: calculaValorFinalProduto(
							item,
							porcentagem,
							item.quantidade
						),
						valor_unitario: calculaValorUnitarioFinalProduto(item, porcentagem),
					};
					return novo;
				}
			});
			listaAtualizada = true;

			porcentagemDeDesconto = porcentagem;
		} else {
			// console.log("Mantem");
			porcentagemDeDesconto = orcamentoResumo.porcentagemDeDesconto;
		}

		// Lista produtos
		if (!listaAtualizada) {
			// console.log("Lista atualizada");
			if (!dados.listaPordutos && !dados.porcentagemDeDesconto) {
				listaPordutos = orcamentoProdutos;
			} else if (dados.listaPordutos) {
				listaPordutos = dados.listaPordutos;
			}
		}

		// Entrada
		if (dados.entrada || dados.entrada === 0) {
			// console.log("Entrada informada");
			entrada = parseFloat(dados.entrada);
		} else {
			entrada = orcamentoResumo.entrada;
		}

		// Frete
		if (dados.frete || dados.frete >= 0) {
			// console.log("Entrada frete");
			frete = parseFloat(dados.frete);
		} else {
			frete = orcamentoResumo.frete;
		}

		// Total com desconto
		let totalComDesconto = 0;
		listaPordutos.forEach((item) => {
			totalComDesconto += calculaValorFinalProduto(
				item,
				item.desconto,
				item.valor_tabela,
				item.quantidade
			);
			// if (item && item.valor_final) totalComDesconto += item.valor_final;
			// else if (item && item.desconto) totalComDesconto += item.desconto;
		});

		// Total sem desconto
		let totalSemDesconto = 0;
		listaPordutos.forEach((item) => {
			if (item && item.valor_tabela)
				totalSemDesconto += item.valor_tabela * item.quantidade;
		});

		if (!listaAtualizada || dados.listaPordutos) {
			if (!dados.listaPordutos && !dados.porcentagemDeDesconto) {
			} else if (dados.listaPordutos) {
				porcentagemDeDesconto = Math.abs(
					((totalComDesconto - totalSemDesconto) / totalSemDesconto) * 100
				);
			}
		}

		if (orcamentoProdutos.length > 0) {
			pagamentoMetodosRef.current.updateCompraProgramada();
			pagamentoMetodosRef.current.updateMercadoPagoSemJuros(
				orcamentoResumo.totalParcelas
			);
		}

		SetPagamentoMetodosSelecteds({});
		SetCompraProgramada([]);
		setMercadoPagoSemJuros([]);
		SetOrcamentoResumo((orcamentoResumo) => ({
			...orcamentoResumo,
			totalComDesconto: totalComDesconto,
			totalSemDesconto: totalSemDesconto,
			porcentagemDeDesconto: porcentagemDeDesconto,
			totalParcelas: totalComDesconto - entrada,
			entrada: entrada,
			frete: frete,
		}));

		console.log("Atualiza Dados:::::::::::::::::::::::::::::");
		console.table(listaPordutos);
		console.table({
			...orcamentoResumo,
			totalComDesconto: totalComDesconto,
			totalSemDesconto: totalSemDesconto,
			porcentagemDeDesconto: porcentagemDeDesconto,
			totalParcelas: totalComDesconto - entrada,
			entrada: entrada,
			frete: frete,
		});
		SetOrcamentoProdutos(listaPordutos);
		setAlertaMuitoDesconto(false);
		if (porcentagemDeDesconto > 35) {
			setAlertaMuitoDesconto(true);
		}
		calcularCompraProgramada(totalComDesconto - entrada);
		// console.log("AtualizaDadosOrcamento-----------------<");
	};

	const calcularCompraProgramada = (totalParcelas = null) => {
		const total = totalParcelas ? totalParcelas : orcamentoResumo.totalParcelas;
		// console.log("calcularCompraProgramada", total);
		let parcelas = [];

		if (compraProgramada.length === 0) {
			for (let i = 1; i <= 12; i++) {
				parcelas.push((total / 12).toFixed(2));
			}
		}
		SetCompraProgramada(parcelas);

		// if (parcelas.length > 0) {
		// 	SetPagamentoMetodosSelecteds({
		// 		...paymentMethodsSelecteds,
		// 		7: {
		// 			name: "Compra programada",
		// 			installments: parcelas.length,
		// 			value: 0,
		// 		},
		// 	});
		// } else {
		// 	const data = [];

		// 	for (var key of Object.keys(paymentMethodsSelecteds)) {
		// 		if (key !== "7") {
		// 			data[key] = paymentMethodsSelecteds[key];
		// 		}
		// 	}
		// 	SetPagamentoMetodosSelecteds(data);
		// }
	};

	const SalvarOrcamento = () => {
		SetSalvandoOrcamento(true);

		// console.log("Salvar Orcamento", orcamentoProdutos);
		const products = [];
		orcamentoProdutos.map((item) => {
			if (item !== "undefined" && item !== "" && item !== undefined) {
				products.push({
					id: item.id,
					categoria: item.categoria,
					desconto: item.desconto,
					nome: item.nome,
					quantidade: item.quantidade,
					valor_final: item.valor_final,
					valor_tabela: item.valor_tabela,
					valor_unitario: item.valor_unitario,
				});
			} else {
				console.log("Erro no item", item);
			}
		});

		const data = {
			negocio_id: pipedriveDealId,
			consultor: infoUsers.negocio.consultor,
			pessoa: infoUsers.negocio.pessoa,
			resumo: orcamentoResumo,
			produtos: products,
			metodosPagamentos: paymentMethodsSelecteds,
			extras: orcamentoExtras,
			compraProgramada: compraProgramada,
			mercadoPagoSemJuros: mercadoPagoSemJuros,
			substituicaoId: urlParams.get("substituicaoId")
				? urlParams.get("substituicaoId")
				: null,
		};

		console.log("Salvando Orçamento", data);

		fetch(config.get("url_api") + "orcamento/salvarNovo", {
			method: "POST",
			headers: {
				"Content-Type": "application/json;charset=utf-8",
			},
			body: JSON.stringify(data),
		})
			.then((response) => response.json())
			.then((jsondata) => {
				SetOrcamentoSalvo(jsondata);
				SetSalvandoOrcamento(false);
				SetRedirecionarAposSalvar(true);
			})
			.catch((error) => {
				toast.error("Erro ao salvar orçamento. " + error);
			});
	};

	const botaoSalvarBloqueado = () => {
		if (salvandoOrcamento) return true;

		if (astecChamadoId != null && orcamentoResumo.porcentagemDeDesconto > 35)
			return true;

		if (
			orcamentoExtras.baseTroca &&
			(orcamentoExtras.baseTrocaProdutos === "" ||
				orcamentoExtras.baseTrocaValor === "" ||
				orcamentoExtras.cNFConsignadoOriginal === "" ||
				orcamentoExtras.dNFConsignadoEmissao === "" ||
				orcamentoExtras.nValorEntrada === "" ||
				orcamentoExtras.nValorEntrada < 1 ||
				orcamentoExtras.cNFConsignadoOriginal.toString().length !== 9)
		) {
			return true;
		}

		const bloqueado =
			!paymentMethodsSelecteds ||
			Object.keys(paymentMethodsSelecteds).length === 0 ||
			orcamentoResumo.totalParcelas <= 0;

		if (bloqueado) return bloqueado;

		if (compraProgramadaSelecionada) return false;

		return bloqueado;
	};

	const voltarParaNegocio = () => {
		window.location.href =
			"https://metalife2.pipedrive.com/deal/" + props.pipedriveDealId;
	};

	const voltarParaChamado = () => {
		window.location.href =
			"https://astec.metalifepilates.com.br/chamados/" +
			astecChamadoId +
			"/edit";
	};
	return (
		<React.Fragment>
			{salvandoOrcamento && (
				<div className="modal-conteiner">
					<div className="salvando-orcamento-modal">
						<div>
							Salvando orçamento
							<br />
							<br />
							<CircularProgress />
						</div>
					</div>
				</div>
			)}

			<Cabecalho
				title={"Criar orçamento"}
				pipedriveDealId={pipedriveDealId}
				astecChamadoId={astecChamadoId}
				voltarParaNegocio={voltarParaNegocio}
				voltarParaChamado={voltarParaChamado}
			></Cabecalho>
			<div className="p-1">
				{redirecionarAposSalvar && (
					<Paper className="mt-1">
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<h2 className="text-center">Orçamento salvo com sucesso!</h2>
								<h4 className="text-center">O que deseja fazer?</h4>
							</Grid>
							<Grid item xs={6} className="text-right">
								{astecChamadoId && astecChamadoId !== "" && (
									<Button
										variant="contained"
										color="default"
										onClick={voltarParaChamado}
									>
										voltar para o chamado
									</Button>
								)}
								{!astecChamadoId && pipedriveDealId && pipedriveDealId !== "" && (
									<Button
										variant="contained"
										color="default"
										onClick={() => {
											window.location.href =
												"https://metalife2.pipedrive.com/deal/" +
												pipedriveDealId;
										}}
									>
										Voltar para o pipedrive
									</Button>
								)}
							</Grid>
							<Grid item xs={6} className="text-left">
								<Button
									variant="contained"
									color="default"
									onClick={() => {
										props.history.push(
											"/orcamento/aceite?orcamentoId=" +
												(orcamentoSalvo ? orcamentoSalvo.id : "")
										);
									}}
								>
									Ir para o aceite deste orçamento
								</Button>
							</Grid>
						</Grid>
					</Paper>
				)}
				{!redirecionarAposSalvar && (
					<Paper>
						<OrcamentoTopo infoUsers={infoUsers}>
							{gruposDeProdutosLista && (
								<AdicionarProduto
									orcamentoProdutos={orcamentoProdutos}
									gruposDeProdutosLista={gruposDeProdutosLista}
                  gruposDeProdutosLinha={gruposDeProdutosLinha}
                  gruposDeProdutosCor={gruposDeProdutosCor}
									AdicionaRemoveProduto={AdicionaRemoveProduto}
									orcamentoResumo={orcamentoResumo}
									AtualizaDadosOrcamento={AtualizaDadosOrcamento}
								/>
							)}
							{!gruposDeProdutosLista && (
								<React.Fragment>
									<Button
										variant="contained"
										disabled
										color="primary"
										size="small"
									>
										INSERIR PRODUTO
									</Button>
									<Button
										className="ml-1"
										variant="contained"
										disabled
										color="primary"
										size="small"
									>
										CARREGAR MODELO
									</Button>
									<Button
										className="ml-1"
										variant="contained"
										disabled
										color="primary"
										size="small"
									>
										COPIAR DE
									</Button>
								</React.Fragment>
							)}
							{infoUsers && gruposDeProdutosLista && (
								<React.Fragment>
									<CarregarModelo
										carregarModelo={carregarModelo}
										consultorID={infoUsers.negocio.consultor.id}
									/>
									<Duplicar
										carregarModelo={carregarModelo}
										negocioId={pipedriveDealId}
									/>
								</React.Fragment>
							)}
						</OrcamentoTopo>
					</Paper>
				)}
				{alertaMuitoDesconto && !redirecionarAposSalvar && (
					<Alert variant="filled" severity="warning" className={"mb-1"}>
						<AlertTitle>Atenção</AlertTitle>
						Este orçamento esta com o desconto maior do que 35%, tem certeza que
						é isso mesmo?
					</Alert>
				)}

				{produtosIndisponiveis.length > 0 && (
					<Alert variant="filled" severity="info" className={"mb-1"}>
						<AlertTitle>
							<div className="d-flex">
								<div className="flex-grow-1">
									Atenção: os produtos abaixo não foram carregados do modelo,
									pois não estão disponiveis
								</div>
								<Button
									variant="contained"
									size="small"
									onClick={() => SetProdutosIndisponiveis([])}
								>
									Fechar
								</Button>
							</div>
						</AlertTitle>
						{produtosIndisponiveis.map((item) => {
							return <b>{item}</b>;
						})}
					</Alert>
				)}

				{produtosAlteracaoValor.length > 0 && (
					<Alert variant="filled" severity="info" className={"mb-1"}>
						<AlertTitle>
							<div className="d-flex">
								<div className="flex-grow-1">
									Atenção: os produtos abaixo tiveram alteração de preço.
								</div>
								<Button
									variant="contained"
									size="small"
									onClick={() => SetProdutosAlteracaoValor([])}
								>
									Fechar
								</Button>
							</div>
						</AlertTitle>
						{produtosAlteracaoValor.map((item) => {
							return <b>{item}</b>;
						})}
					</Alert>
				)}

				{!redirecionarAposSalvar && orcamentoProdutos.length > 0 && (
					<Grid container spacing={3}>
						<Grid item xs={3}>
							<Paper className="mb-1">
								<OrcamentoResumo
									orcamentoResumo={orcamentoResumo}
									SetOrcamentoResumo={SetOrcamentoResumo}
									updateCompraProgramada={updateCompraProgramada}
									updateMercadoPagoSemJuros={updateMercadoPagoSemJuros}
									orcamentoProdutos={orcamentoProdutos}
									AtualizaDadosOrcamento={AtualizaDadosOrcamento}
									orcamentoExtras={orcamentoExtras}
									astecChamadoId={astecChamadoId}
								/>
							</Paper>
							<Paper className="mb-1">
								<OrcamentoBaseTroca
									orcamentoExtras={orcamentoExtras}
									SetOrcamentoExtras={SetOrcamentoExtras}
								/>
							</Paper>
							<Paper className="mb-1">
								<OrcamentoExtras
									orcamentoExtras={orcamentoExtras}
									SetOrcamentoExtras={SetOrcamentoExtras}
								/>
							</Paper>
							<Paper className="mb-1">
								<MetodosPagamentoSelecionado
									paymentMethodsSelecteds={paymentMethodsSelecteds}
									SetPagamentoMetodosSelecteds={SetPagamentoMetodosSelecteds}
									SetCompraProgramada={SetCompraProgramada}
									SetCompraProgramadaSelecionada={
										SetCompraProgramadaSelecionada
									}
									compraProgramadaSelecionada={compraProgramadaSelecionada}
									compraProgramada={compraProgramada}
								/>
							</Paper>
							<Paper className="p-1">
								<Button
									onClick={() => SalvarOrcamento()}
									variant="contained"
									fullWidth
									disabled={botaoSalvarBloqueado()}
									color="primary"
									className="mb-1"
								>
									{!salvandoOrcamento ? "Salvar" : "Salvando..."}
								</Button>
								<SalvarModelo
									infoUsers={infoUsers}
									orcamentoResumo={orcamentoResumo}
									orcamentoProdutos={orcamentoProdutos}
									paymentMethodsOpen={paymentMethodsOpen}
									orcamentoExtras={orcamentoExtras}
									compraProgramada={compraProgramada}
									mercadoPagoSemJuros={mercadoPagoSemJuros}
									disabled={
										orcamentoResumo.totalParcelas <= 0 ||
										compraProgramada[compraProgramada.length - 1] <= 0 ||
										salvandoOrcamento
									}
								/>
							</Paper>
						</Grid>
						<Grid item xs={9}>
							<Paper>
								<ProdutosAdicionados
									SetOrcamentoProdutos={SetOrcamentoProdutos}
									orcamentoProdutos={orcamentoProdutos}
									AdicionaRemoveProduto={AdicionaRemoveProduto}
									orcamentoResumo={orcamentoResumo}
									AtualizaDadosOrcamento={AtualizaDadosOrcamento}
								/>
							</Paper>

							<MetodosPagamento
								ref={pagamentoMetodosRef}
								paymentMethods={paymentMethods}
								SetPagamentoMetodosOpen={SetPagamentoMetodosOpen}
								SetPagamentoMetodosSelecteds={SetPagamentoMetodosSelecteds}
								paymentMethodsSelecteds={paymentMethodsSelecteds}
								paymentMethodsOpen={paymentMethodsOpen}
								orcamentoResumo={orcamentoResumo}
								compraProgramada={compraProgramada}
								mercadoPagoSemJuros={mercadoPagoSemJuros}
								SetCompraProgramada={SetCompraProgramada}
								setMercadoPagoSemJuros={setMercadoPagoSemJuros}
								calcularCompraProgramada={calcularCompraProgramada}
								SetCompraProgramadaSelecionada={SetCompraProgramadaSelecionada}
								compraProgramadaSelecionada={compraProgramadaSelecionada}
							/>
						</Grid>
					</Grid>
				)}
			</div>
		</React.Fragment>
	);
};

export default OrcamentoPagina;
